import * as React from "react"

import Layout from "../components/Layout"

const ProjectSitePlan = () => {
  return (
    <Layout>
      <h3>From External Landscape To Your Smart Home and Kitchen Decor ...</h3>

      <iframe
        title="Project_Landscape_Kitchen_Decor"
        width="100%"
        height="600px"
        src="/ExternalLandscapeInternalDecor.pdf#toolbar=0"
      ></iframe>
    </Layout>
  )
}

export default ProjectSitePlan
